import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updateShopMilesFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    !bookWidgetFieldsMasterConfig.shopMilesField?.hide &&
    !bookWidgetFieldsMasterConfig.shopMilesField?.disable
  ) {
    let checked = false;
    if (retrieveSearchData?.awardTravel) {
      checked = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      shopMilesField: {
        ...updatedBookWidgetFields.shopMilesField,
        checked,
        disable: false,
        hide: false
      }
    };
  }

  return updatedBookWidgetFields;
};
